//const URL = "https://lantmannen.addamig.se/api";
const URL = "https://odla-api-dev.azurewebsites.net/api";
 
const BEST_STRATEGIES = 3;
const AVERAGE_STRATEGIES = 2;
const WORST_STRATEGIES = 1;
const NO_DATA = 0;

const RED = '#ea8c00';
const YELLOW = '#ffd962';
const GREEN = '#afcc46';

export {
  BEST_STRATEGIES,
  AVERAGE_STRATEGIES,
  WORST_STRATEGIES,
  NO_DATA,
  URL,
  GREEN,
  YELLOW,
  RED
}
